import DataMutations from '../graphql/Mutations';
import DataQueries   from '../graphql/Queries';
import mainPageModel from '../main-navigation/MainPageModel';
import DocumentDialogModel, {
  DocumentSchema
} from './DocumentDialogModel';

export class AreaDialogModel extends DocumentDialogModel {
  constructor() {
    super(
      'Area',
      (ids: string[]) => DataQueries.getAreasByIds(DocumentSchema, ids),
      DataMutations.insertAreas,
      DataMutations.updateAreas,
      DataMutations.deleteAreas,
      'areas',
      () => mainPageModel.canAddAreas,
      () => mainPageModel.canEditAreas,
      () => mainPageModel.canDeleteAreas,
    );
  }
}

const areaDialogModel = new AreaDialogModel();
export default areaDialogModel;